<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="500px">
    <v-card v-if="userInfo">
      <v-card-title class="title">
        <span class="ui-dialog-title" v-html="userInfo.username" />
        <v-btn flat icon color="blue lighten-2" @click="closeDialog()">
          <v-icon color="#fff">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="!getLoading" class="content-modl">
        <p>
          <strong>Burner model:</strong>
          {{userInfo.model}}
        </p>
        <p>
          <strong>Boiler:</strong>
          {{userInfo.boiler}}
        </p>
        <p>
          <strong>M2 heated:</strong>
          {{userInfo.m2heated}}
        </p>
        <p>
          <strong>Owner:</strong>
          <span v-html="userInfo.fullname" />
        </p>
        <p>
          <strong>Location:</strong>
          <!-- {{userInfo.city}} -->
          <span v-html="userInfo.city" />
        </p>
        <!-- <p>
          {{userInfo}}
          <strong>Online Data:</strong>
          <a @click="window.location = `https://stokercloud.dk/dev/${userInfo.username}.html`">
          Click Here</a>
        </p> -->
        <p style="text-align: center;">
          <v-btn class="link-button" small color="#7a9d0b" dark
          @click="openURL">
            Online Data</v-btn></p>
        <ul>
          <li>
            <img :src="userInfo.weathericon" width="50" />
          </li>
          <li>
            <img
              :src="`http://stokercloud.dk/images/winddir/winddir.php?winddir=${userInfo.windicon}`"
              width="35"
            />
          </li>
          <li>
            <img src="http://stokercloud.dk/dev/res/systemicons/woody.jpg" width="100" />
          </li>
        </ul>
        <h4 class="text-center">
          <i v-html="userInfo.weathercity" />
        </h4>
        <p>{{userInfo.temperature}} °C air temperature</p>
        <p>{{userInfo.humidity}} % humidity</p>
        <p>{{userInfo.pressure}} hPa pressure</p>
        <p>{{userInfo.windspeed}} m/s wind speed</p>
        <p>
          <small>
            Weather data from
            <a href="http://openweathermap.org/">openweathermap.org</a>
          </small>
        </p>
      </v-card-text>
      <v-card-text v-else class="content-modl">
        <loading></loading>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalService from "../services/global-service";
import Loading from "../components/Loading";

export default {
  name: "UserInfoWindow",
  components: {
    Loading
  },
  data() {
    return {
      dialog: false,
      userInfo: {},
      getLoading: false
    };
  },
  props: {
    userId: {
      type: String,
      default: ""
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      if (newVal) {
        // console.log("val: ", newVal);
        this.fecthUserInfo();
      }
    }
  },
  methods: {
    async fecthUserInfo() {
      this.getLoading = true;
      this.userInfo = await GlobalService.getUserInfo(this.userId);
      this.getLoading = false;
    },
    openURL(){
      window.location = `https://stokercloud.dk/dev/${this.userInfo.username}.html`
    }
  }
};
</script>
<style scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.v-card__title {
  background-color: rgb(84, 110, 122);
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
  letter-spacing: 0.005em;
  font-weight: 400;
  width: 100%;
  height: 64px;
  max-height: 64px;
  padding: 0 16px;
  margin: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-dialog {
  border-radius: 4px;
  overflow: hidden;
}
.raised-btn {
  background-color: rgb(250, 250, 250);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.primary-btn {
  background-color: rgb(84, 110, 122);
  color: #fff !important;
}
.theme--light.v-btn svg {
  fill: #455a64;
}
.content-modl {
  min-height: 250px;
  text-align: left;
}
.content-modl p {
  margin-bottom: 0;
}
.content-modl p strong {
  min-width: 100px;
  display: inline-block;
}
.content-modl ul {
  padding: 0;
  margin: 0;
}
.content-modl ul li {
  display: inline-block;
}
.content-modl h4 {
  background-color: #eee;
  margin: 5px 0;
  padding: 5px;
}
.link-button {
  border-radius: 200px;
  padding: 0 20px;
}
</style>

<style>
#app .v-overlay,
#app .v-dialog__content {
  z-index: 555 !important;
}
</style>
